// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"844":"f1dcaaa3","909":"1b5adfe1"}[chunkId] + ".css";
};